import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
export const LeaderItemSkeleton: FC = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="min-w-[28px] rounded-[6px] bg-[#00000040] px-2 py-0.5 sm-tablet:min-w-[38px] sm-tablet:rounded-[8px] sm-tablet:px-[15px] sm-tablet:py-[2.5px]"><div className="h-[16px] w-[14px] rounded bg-white/20 sm-tablet:h-[20px] sm-tablet:w-[18px]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full flex-grow items-center gap-2"><div className="h-[16px] w-[100px] rounded bg-white/20 sm-tablet:h-[20px] sm-tablet:w-[140px]" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex w-full animate-pulse items-center justify-between gap-2 rounded-[10px] bg-[#31324B99] p-1 align-baseline sm-tablet:gap-3 sm-tablet:p-2">{t0}{t1}<div className="flex items-center gap-1 rounded-full bg-[#00000040] px-2 py-1 sm-tablet:px-2.5"><div className="h-[18px] w-[18px] rounded-full bg-white/20 sm-tablet:h-[20px] sm-tablet:w-[20px]" /><div className="h-[22px] w-[45px] rounded bg-white/20 sm-tablet:h-[24px] sm-tablet:w-[55px]" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};